<template>
    <!--修改密码-->
    <div>
        <div class="aFlex c-page-top">
            <div class="c-page-title">修改密码</div>
        </div>
        <!--<div class="ajFlex g-page-top">-->
            <!--<div class="g-page-title">修改密码</div>-->
            <!--<Button size="large" type="info" ghost style="margin-right: 10px" @click="handleCancel">返回</Button>-->
        <!--</div>-->
        <Form class="form-list"  style="padding-top: 20px" ref="formInline" :model="formInline" :rules="ruleInline" inline :label-width="150" label-position="right">
            <Row :gutter="16">
                <Col span="10" offset="4">
                    <FormItem label="原始密码：" prop="oldPassword" class="old-pass">
                        <Input v-model="formInline.oldPassword" type="password"  placeholder="" size="large"></Input>
                        <Icon v-if="oldTrue" class="old-ico"  type="md-checkmark-circle-outline" />
                    </FormItem>
                </Col>
                <Col span="10" offset="4">
                    <FormItem label="新密码：" prop="password">
                        <Input v-model="formInline.password" type="password"  placeholder="" size="large"></Input>
                    </FormItem>
                </Col>
                <Col span="10" offset="4">
                    <FormItem label="确认密码：" prop="passwdCheck">
                        <Input v-model="formInline.passwdCheck" type="password"  placeholder="" size="large"></Input>
                    </FormItem>
                </Col>
                <Col span="10" offset="4">
                    <div class="cFlex">
                        <Button type="primary" size="large" @click="handleSubmit('formInline')" :loading="loading">提交</Button>
                        <Button style="margin-left: 20px" size="large" @click="handleBack">取消</Button>
                    </div>
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>
    export default {
        data(){
            const validateOld = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入旧密码!'));
                } else {
                    this.axios({
                        method: 'post',
                        url: '/getUserByUuidandPwd',
                        data: {
                            password:value,
                            userUUid: localStorage.getItem('userUuid')
                        },
                    }).then((response) => {
                        if(response.data){
                            this.oldTrue=true;
                            callback();
                            if (this.formInline.password !== '') {
                                this.$refs.formInline.validateField('password');
                            }
                        }else{
                            this.oldTrue=false;
                            callback(new Error('旧密码不正确!'));
                        }
                    }).catch(() => {
                        callback(new Error('旧密码验证失败!'));
                    })
                }
            };
            const validatePass = (rule, value, callback) => {
                let reg=/^.{6,18}$/;
                if (value === '') {
                    callback(new Error('请输入新密码!'));
                } else {
                    if (value === this.formInline.oldPassword) {
                        callback(new Error('新旧密码不能相同!'));
                    }else if(reg.test(value)){
                        if (this.formInline.passwdCheck !== '') {
                            // 对第二个密码框单独验证
                            this.$refs.formInline.validateField('passwdCheck');
                        }
                        callback();
                    }else {
                        callback('密码必须6-18位');
                    }
                }
            };
            const validatePassCheck = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入确认密码!'));
                } else if (value !== this.formInline.password) {
                    callback(new Error('两次密码输入不一致!'));
                } else {
                    callback();
                }
            };
            return{
                loading:false,
                oldTrue:false,
                formInline: {
                    oldPassword:'',
                    password: '',
                    passwdCheck: '',
                },
                ruleInline: {
                    oldPassword: [
                        // {required:true, validator: validateOld, trigger: 'blur' }
                        { required: true,  message: '旧密码不能为空', trigger: 'blur' }
                    ],
                    password: [
                        {required:true,  validator: validatePass, trigger: 'blur' }
                    ],
                    passwdCheck: [
                        {required:true, validator: validatePassCheck, trigger: 'blur' }
                    ],
                },
            };
        },
        created(){

        },
        methods:{
            handleBack(){
                this.$router.go(-1);
            },
            /*确认提交*/
            handleSubmit(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.axios({
                            method: 'post',
                            url: '/user/updateTenantUserPassword',
                            data: {
                                oldPassword:this.formInline.oldPassword,
                                password:this.formInline.password,
                                id:localStorage.getItem('userId'),
                            },
                        }).then((response) => {
                            if(response.data.success){
                                // this.$Message.success('修改密码成功!');
                                if(response.data.data) {
                                    this.$Modal.success({
                                        title:'提示',
                                        content:'修改密码成功!',
                                    });
                                    this.handleCancel('index')
                                }else {
                                    this.$Modal.error({
                                        title:'提示',
                                        content:response.data.msg,
                                    });
                                }
                                
                            }else{
                                this.$Modal.warning({
                                    title:'提示',
                                    content:response.data.message,
                                });
                                // this.$Message.error(response.data.message);
                            }
                        }).catch( () =>{
                            this.$Message.error('网络异常!');
                        });
                    }
                });
            },
            /*取消返回*/
            handleCancel(name) {
                this.$store.dispatch('users/loginOUt', {
                    'router': this.$router,
                });
            },
        },
    };
</script>

<style scoped>
    .old-pass{
        position: relative;
    }
    .old-ico{
        position: absolute;
        right: -30px;
        top: 8px;
        color: #4CD63E;
        font-size: 22px;
    }
</style>
